import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core'
import { YoutubeService } from './services/youtube.service'
import { CommonModule } from '@angular/common'
import { SafeUrlPipe } from '../../shared/pipes/safe-url.pipe'
import { MatCardModule } from '@angular/material/card'
import { CarouselModule } from 'primeng/carousel'

@Component({
    selector: 'youtube',
    standalone: true,
    imports: [
        CommonModule,
        MatCardModule,
        SafeUrlPipe,
        CarouselModule
    ],
    templateUrl: 'youtube.component.html',
    styleUrl: './youtube.component.css'
})
export class VideosComponent implements OnInit {
  @ViewChild('carousel', { static: true }) carousel!: ElementRef
  videos: any[] = []
  errorLoadingVideos = false

  constructor(
    private youtubeService: YoutubeService
  ) {}

  ngOnInit() {
    this.loadVideos()
  }

  loadVideos() {
    this.youtubeService.getVideos()
    .subscribe(response => {
      if (response && response.length > 0) {
        this.videos = response
        .filter((v: any)=>!v.snippet.title.includes('#short'))
        .map((item: any) => ({
          videoId: item.id.videoId ?? '',
          title: item.snippet.title,
          thumbnail: item.snippet.thumbnails.high.url,
        }))
        this.errorLoadingVideos = false
      } else this.errorLoadingVideos = true
    })
  }

  responsiveOptions = [
    {
      breakpoint: '1024px',
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: '568px',
      numVisible: 2,
      numScroll: 1,
    },
  ]
}